var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigLeafDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 203,
    viewBox: "0 0 174 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.671 46.9843C147.228 54.5874 118.027 45.522 107.468 11.844C111.176 11.6856 112.787 16.1838 125.944 15.9056C145.26 13.9487 157.554 20.1548 166.671 46.9843Z",
    fill: "#28601A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3191 77.7124C63.3336 89.8491 32.8012 88.218 14.3095 58.1554C17.8649 57.0932 20.5293 61.0592 33.2169 57.5646C51.464 50.9327 64.9038 53.9362 80.3191 77.7124Z",
    fill: "#28601A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.107 87.8574C126.849 95.916 97.4427 87.5404 86.0942 54.1202C89.7967 53.8746 91.5131 58.3336 104.66 57.7459C123.925 55.3349 136.361 61.25 146.107 87.8574Z",
    fill: "#ECE537"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.202 124.002C117.86 135.623 87.3902 133.077 69.8092 102.472C73.3949 101.517 75.939 105.562 88.7258 102.449C107.164 96.3682 120.507 99.7738 135.202 124.002Z",
    fill: "#28601A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2331 131.142C53.2582 143.293 22.7243 141.689 4.20647 111.642C7.76089 110.577 10.4287 114.541 23.1133 111.035C41.3546 104.387 54.797 107.379 70.2331 131.142Z",
    fill: "#ECE537"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.907 149.373C114.167 169.703 90.1623 188.642 56.4235 178.279C58.3918 175.134 63.0117 176.352 70.2312 165.349C79.5536 148.319 91.6293 141.699 118.907 149.373Z",
    fill: "#28601A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.543 133.019C170.294 150.913 166.245 181.22 134.811 197.269C134.034 193.64 138.199 191.299 135.722 178.374C130.558 159.658 134.618 146.499 159.543 133.019Z",
    fill: "#28601A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLeafDark);
export default __webpack_public_path__ + "static/media/bigLeafDark.f41f44d2c8f9b8ecc2f8c040e7d45e88.svg";
export { ForwardRef as ReactComponent };